<template>
    <b-form class="user-multiple-form needs-validation w-100" validate @submit.prevent="validateProduct">
        <div class="d-flex justify-content-center h-50 align-items-center" v-if="loading">
            <b-spinner variant="info" style="width: 7rem; height: 7rem;"/>
        </div>
        <template v-else>
            <div class="user-multiple-form__row">
                <b-row>
                    <b-col md="8">
                        <b-form-group label-for="product_name" label="Product Name*">
                            <b-form-input
                                v-model="productInstance.name"
                                type="text"
                                id="product_name"
                                name="product_name"
                                v-validate="'required'"
                                :class="{'is-invalid': errors.has('product_name') }"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group description="Notice: First uploaded image will be Main!" class="mb-0">
                            <label class="btn btn-block mb-0 upload-img-btn"
                                   :class="{'btn-outline-danger': errors.has('product_image'), 'btn-outline-user-primary': !errors.has('product_image')}">
                                <span class="text-dark font-weight-bold">Add image</span>
                                <input type="file"
                                       name="product_image"
                                       multiple
                                       v-validate="imagePreviews.length > 0 ? null : 'required'"
                                       class="d-none"
                                       accept="image/*"
                                       ref="images"
                                       @change="handleFilesUpload">
                            </label>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="field-add-image" v-show="imagePreviews.length > 0">
                    <b-col cols="auto">
                        <ul class="image-list">
                            <li class="image-list__item"
                                v-for="(image, index) in imagePreviews"
                                :class="{'wrap-main-img': index === 0}"
                                :key="'preview-' + index">
                                <span v-if="index === 0" class="position-absolute">Main*</span>
                                <img :src="image.imageUrl" alt="server error image" class="product-img">
                                <button type="button"
                                        class="btn btn-close text-red"
                                        @click="removeImg(image)">&times;
                                </button>
                            </li>
                        </ul>
                    </b-col>
                </b-row>
            </div>
            <div class="user-multiple-form__row">
                <b-row align-v="end">
                    <b-col md="2">
                        <b-form-group label-for="product_value" label="Value (€)*">
                            <b-form-input
                                :value="productInstance.value"
                                @input="productInstance.value = $event.replace(/^0+/, '0')"
                                type="text"
                                v-validate="{required: true, min_value:0.01, regex:/^(\d+|\d+(\.|,)\d{1,2})$/}"
                                name="product_value"
                                :class="{'is-invalid': errors.has('product_value') }"
                                class="w-50"
                                id="product_value"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <div class="user-multiple-form__row">
                <b-row align-v="start">
                    <b-col md="2">
                        <b-form-group label-for="product_weight" label="Weight(kg)*">
                            <b-form-input
                                :value="productInstance.weight"
                                @input="productInstance.weight = $event.replace(/^0+/, '0')"
                                type="text"
                                v-validate="{required:true, min_value:0.001, regex:/^(\d+|\d+(\.|,)\d{1,3})$/}"
                                id="product_weight"
                                name="product_weight"
                                :class="{'is-invalid': errors.has('product_weight') }"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="5">
                        <b-form-group label-for="product_dimensions_length" label="Dimensions(cm)*">
                            <b-row>
                                <b-col cols="4">
                                    <b-form-input
                                        :value="productInstance.length"
                                        @input="productInstance.length = $event.replace(/^0+/, '0')"
                                        placeholder="Length(cm)*"
                                        type="text"
                                        v-validate="{required:true, min_value:0.01, regex:/^(\d+|\d+(\.|,)\d{1,2})$/}"
                                        id="product_dimensions_length"
                                        name="product_dimensions_length"
                                        :class="{'is-invalid': errors.has('product_dimensions_length') }"/>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-input
                                        :value="productInstance.width"
                                        @input="productInstance.width = $event.replace(/^0+/, '0')"
                                        placeholder="Width(cm)*"
                                        type="text"
                                        v-numeric-only
                                        v-validate="{required:true, min_value:0.01, regex:/^(\d+|\d+(\.|,)\d{1,2})$/}"
                                        id="product_dimensions_width"
                                        name="product_dimensions_width"
                                        :class="{'is-invalid': errors.has('product_dimensions_width') }"/>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-input
                                        :value="productInstance.height"
                                        @input="productInstance.height = $event.replace(/^0+/, '0')"
                                        placeholder="Height(cm)*"
                                        type="text"
                                        v-numeric-only
                                        v-validate="{required:true, min_value:0.01, regex:/^(\d+|\d+(\.|,)\d{1,2})$/}"
                                        id="product_dimensions_height"
                                        name="product_dimensions_height"
                                        :class="{'is-invalid': errors.has('product_dimensions_height') }"/>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <div class="user-multiple-form__row">
                <b-row>
                    <b-col md="3">
                        <b-form-group label-for="product_sku" label="SKU*">
                            <b-form-input
                                v-model="productInstance.sku"
                                type="text"
                                v-validate="{required:true}"
                                id="product_sku"
                                name="product_sku"
                                :class="{'is-invalid': errors.has('product_sku') }"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="4" v-if="editMode">
                        <b-form-group label-for="product_fnsku" label="FNSKU">
                            <b-form-input
                                v-model="fnsku"
                                id="product_fnsku"
                                value="#12345L2LK54"
                                :disabled="true"/>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="1">
                        <b-form-group label-for="product_size" label="Size">
                            <b-form-input
                                v-model="productInstance.size"
                                id="product_size"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="1">
                        <b-form-group label-for="product_color" label="Color">
                            <b-form-input
                                v-model="productInstance.color"
                                id="product_color"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label-for="product_condition" label="Condition">
                            <b-form-input
                                v-model="productInstance.condition"
                                id="product_condition"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label-for="product_manufacturer" label="Manufacturer">
                            <b-form-input
                                v-model="productInstance.manufacturer"
                                id="product_manufacturer"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <div class="user-multiple-form__row">
                <b-row>
                    <b-col md="4">
                        <b-form-group label-for="product_description" label="Description">
                            <b-form-textarea
                                id="product_description"
                                v-model="productInstance.description"
                                rows="6"
                                max-rows="6"
                                name="product_description"/>
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label-for="product_comments" label="Comments">
                            <b-form-textarea
                                id="product_comments"
                                v-model="productInstance.comment"
                                rows="6"
                                max-rows="6"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-btn variant="primary-user"
                               class="mt-3"
                               type="submit">{{editMode && !$route.query.suspended ? 'Save changes' : 'Add Product'}}
                        </b-btn>
                    </b-col>
                </b-row>
            </div>
        </template>
    </b-form>
</template>

<script>
    import { numericOnly } from '@/directives/numericOnly'
    export default {
        name: 'SingleProduct',
        props: ['productId'],
        data() {
            return {
                loading: false,
                editMode: false,
                fnsku: '',
                productInstance: {
                    name: '',
                    sku: '',
                    upc: null,
                    manufacturer: '',
                    description: '',
                    price: null,
                    value: '',
                    currencyCode: 'EUR',
                    status: 'inactive',
                    categories: [],
                    color: '',
                    size: '',
                    weight: null,
                    length: null,
                    width: null,
                    height: null,
                    condition: '',
                    comment: '',
                },
                images: [],
                imagePreviews: [],
                existentImages: []
            }
        },
        directives: {
            numericOnly
        },
        created() {
            if (this.$route.params.id) {
                this.editMode = true
                this.getProduct()
            }
            if (this.productId) {
                this.editMode = true
                this.getProduct()
            }
        },
        watch: {
            '$route.path': function() {
                Object.assign(this.$data, this.$options.data())
                this.$validator.reset()
            }
        },
        methods: {
            getProduct() {
                this.loading = true
                let {productInstance} = this
                this.$api('GET', this.$endpoints.singleProduct(this.$route.params.id || this.productId)).then(response => {
                    productInstance.name = response.name
                    productInstance.sku = response.sku
                    productInstance.upc = response.upc
                    productInstance.manufacturer = response.manufacturer
                    productInstance.description = response.description ? response.description.replace(/<[^>]*>?/gm, '') : null
                    productInstance.price = response.price
                    productInstance.value = response.value === 0 ? '' : response.value
                    productInstance.status = response.status
                    productInstance.color = response.properties.color
                    productInstance.size = response.properties.size
                    productInstance.weight = response.dimensions.weight
                    productInstance.length = response.dimensions.length
                    productInstance.width = response.dimensions.width
                    productInstance.height = response.dimensions.height
                    productInstance.condition = response.condition
                    productInstance.comment = response.comments.comment

                    this.fnsku = response.fnsku
                    this.imagePreviews = response.images
                    this.existentImages = response.images
                    this.loading = false
                    if (this.productInstance.status === 'suspended') {
                        this.$store.dispatch('globalAlertAction', {
                            type: 'warning',
                            title: 'You need to fill up required product fields!',
                            timeout: 15000
                        }).then(() => this.$validator.validateAll())
                    }
                })
            },
            handleFilesUpload() {
                let arr = Array.from(this.$refs.images.files)
                for (let i = 0; i < arr.length; i++) {
                    let index = this.images.findIndex(item => item.name === arr[i].name)
                    if (index === -1) {
                        this.images.push(arr[i])
                    }
                }
                this.imagePreviews = this.editMode ? [...this.existentImages] : []
                this.getImagePreviews()
            },
            getImagePreviews() {
                if (this.images.length !== 0) {
                    let c = 0
                    let convert = i => {
                        if (this.images[i] && /\.(jpe?g|png|gif)$/i.test(this.images[i].name)) {
                            let reader = new FileReader()
                            reader.addEventListener('load', () => {
                                this.imagePreviews.push({imageUrl: reader.result, id: this.images[i].name})
                                c++
                                convert(c)
                            }, false)

                            reader.readAsDataURL(this.images[i])
                        }
                    }
                    convert(c)
                }
            },
            removeImg(image) {
                if (image.updatedAt === undefined) {
                    this.images = this.images.filter(item => item.name !== image.id)
                    this.imagePreviews = this.imagePreviews.filter(item => item.updatedAt !== undefined)
                    this.getImagePreviews()
                    return
                }
                this.$api('DELETE', this.$endpoints.productImg(this.$route.params.id) + `/${image.id}`).then(response => {
                    this.imagePreviews = this.imagePreviews.filter(item => item.id !== image.id)
                    // TODO: fix response
                    this.existentImages = response
                })
            },
            validateProduct() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        if (this.editMode) {
                            this.editProduct()
                        } else {
                            this.createProduct()
                        }
                    } else {
                        console.log('error')
                    }
                })
            },
            editProduct() {
                this.sendProductData('PUT', this.$endpoints.singleProduct(this.$route.params.id || this.productId), 'edit')
            },
            createProduct() {
                this.sendProductData('POST', this.$endpoints.products)
            },
            sendProductData(apiMethod, endpoint, edit) {
                const productBody = {...this.productInstance}
                if (this.productInstance.status === 'suspended') {
                    productBody.status = 'inactive'
                }

                this.$api(apiMethod, endpoint, productBody)
                    .then(response => {
                        if (this.images.length > 0) {
                            this.sendImages(response.id)
                        }
                        this.successNotification()
                    })
                    .finally(() => {
                        this.loading = false
                        if (edit) {
                            this.$emit('editProduct')
                        }
                    })
            },
            successNotification() {
                let textNotification = ''
                let success = () => {
                    this.$store.dispatch('globalAlertAction', {
                        type: 'success',
                        title: textNotification,
                        timeout: 10000
                    })
                }

                if (this.$route.query.suspended || !this.editMode) {
                    textNotification = 'The product was saved successfully!'
                    success()
                    this.$route.query.suspended ? this.$router.push({name: 'IntegrateProducts'}) : this.$router.push({name: 'AddProducts'})
                    Object.assign(this.$data, this.$options.data())
                    this.productInstance.categories = []
                    this.$validator.reset()
                    return false
                }

                if (this.editMode) {
                    textNotification = 'Changes saved successfully'
                    success()
                }
            },
            sendImages(id) {
                let headers = {
                    'Content-Type': 'multipart/form-data'
                }
                for (let i = 0; i < this.images.length; i++) {
                    let formData = new FormData()
                    formData.set('image', this.images[i])
                    this.$api('POST', this.$endpoints.productImg(id), formData, null, headers)
                }
            }
        }
    }
</script>

<style lang="scss">
    .user-multiple-form {
        label {
            font-size: 15px;
        }
        ::placeholder {
            font-size: 12px;
        }
    }
    .wrap-main-img {
        position: relative;
        span {
            position: absolute;
            top: -30px;
            font-size: 1rem;
            font-weight: 600;
        }
        .btn-primary-user {
            cursor: inherit;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/SingleProduct.vue